import { Outlet } from 'react-router-dom';

export default function User() {
  return (
    <div style={{ marginTop: '100px' }}>
      <Outlet />
    </div>
  );
}
